import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Badge, Button, Input, Panel } from '@usacow/ds';
import { api, type Assignment } from '../lib/api';

export function Assignments() {
  const navigate = useNavigate();
  const [items, setItems] = useState<Assignment[] | null>(null);
  const [code, setCode] = useState('');
  const [joinMsg, setJoinMsg] = useState<string | null>(null);

  async function load() {
    const r = await api.getAssignments();
    setItems(r.assignments);
  }
  useEffect(() => {
    void load();
  }, []);

  async function join() {
    if (!code.trim()) return;
    const r = await api.joinClass(code.trim());
    setJoinMsg(r.ok ? 'Joined.' : 'No class with that code.');
    setCode('');
    if (r.ok) await load();
  }

  return (
    <div className="scr scr--narrow">
      <div className="scr-head">
        <div>
          <div className="t-eyebrow">assignments</div>
          <h1 className="scr-h">Your assignments</h1>
        </div>
      </div>

      <Panel title="Join a class" style={{ marginBottom: 16 }}>
        <div className="coach-join">
          <Input
            mono
            value={code}
            onChange={(e) => setCode(e.target.value)}
            placeholder="JOIN CODE"
          />
          <Button variant="secondary" onClick={join}>
            Join
          </Button>
        </div>
        {joinMsg && (
          <p className="dim" style={{ marginTop: 8 }}>
            {joinMsg}
          </p>
        )}
      </Panel>

      {!items ? (
        <div className="dim">Loading…</div>
      ) : items.length === 0 ? (
        <p className="dim">No assignments. Join a class with a code from your coach.</p>
      ) : (
        <div className="asg-list">
          {items.map((a) => (
            <div className="asg-row" key={a.id}>
              <div>
                <div className="asg-row__t">{a.title}</div>
                <div className="asg-row__m dim">
                  {a.class_name} · {a.difficulty}
                </div>
              </div>
              <div className="asg-row__r">
                {a.status === 'completed' ? (
                  <Badge tone="correct" variant="outline">
                    done
                  </Badge>
                ) : (
                  <Button
                    variant="primary"
                    size="sm"
                    onClick={async () => {
                      await api.completeAssignment(a.id).catch(() => {});
                      if (a.kind && a.target_ref) navigate(`/app/drill/${a.target_ref}`);
                      else await load();
                    }}
                  >
                    Start
                  </Button>
                )}
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
